import { useState } from "react";
import api, { telecharger } from "../api";

/**
 * Import d'un parc depuis un fichier Excel.
 *
 * DEUX TEMPS, et c'est tout l'interet de l'ecran :
 *
 *   1. on televerse -> le serveur dit ce qu'il FERAIT, sans rien ecrire ;
 *   2. on confirme  -> il ecrit.
 *
 * Sans le premier temps, un fichier mal forme cree quarante doublons chez un
 * client et on les reprend a la main. Les lignes rejetees sont affichees AVEC
 * leur motif et leur numero de ligne : une ligne avalee en silence est pire
 * qu'une erreur.
 *
 * Le meme composant sert a l'editeur (a l'accueil d'un client) et a
 * l'administrateur du client (ses nouveaux camions).
 */
export default function ImportVehicules({ url, titre, sousTitre, onFini, onFermer }) {
  const [fichier, setFichier] = useState(null);
  const [apercu, setApercu] = useState(null);
  const [resultat, setResultat] = useState(null);
  const [erreur, setErreur] = useState("");
  const [enCours, setEnCours] = useState(false);

  const envoyer = (appliquer) => {
    if (!fichier) return;
    setEnCours(true);
    setErreur("");
    const corps = new FormData();
    corps.append("fichier", fichier);
    api
      .post(`${url}?appliquer=${appliquer}`, corps)
      .then(({ data }) => {
        if (appliquer) {
          setResultat(data);
          onFini && onFini(data);
        } else {
          setApercu(data);
        }
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail;
        setErreur(typeof detail === "string" ? detail : "Import impossible.");
        setApercu(null);
      })
      .finally(() => setEnCours(false));
  };

  const choisir = (f) => {
    setFichier(f);
    setApercu(null);
    setResultat(null);
    setErreur("");
  };

  return (
    <div className="modal-overlay" onClick={onFermer}>
      <div className="modal-carte modal-large" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-titre">{titre}</h3>
        {sousTitre && <p className="modal-sous-titre">{sousTitre}</p>}

        {!resultat && (
          <>
            <label className="modal-champ">
              Fichier Excel (.xlsx)
              <input
                type="file"
                accept=".xlsx"
                onChange={(e) => choisir(e.target.files[0] || null)}
              />
            </label>
            <p className="sous-info">
              Le fichier doit contenir une feuille « Vehicules ».{" "}
              <button
                type="button"
                className="lien-action"
                onClick={() =>
                  telecharger(
                    "/vehicules/import/modele",
                    "modele-import-vehicules.xlsx"
                  ).catch(() => setErreur("Téléchargement du modèle impossible."))
                }
              >
                Télécharger le modèle
              </button>
            </p>
          </>
        )}

        {erreur && <p className="erreur">{erreur}</p>}

        {/* Apercu : ce que le serveur ferait. Rien n'est encore ecrit. */}
        {apercu && !resultat && (
          <div className="import-apercu">
            <div className="import-compteurs">
              <span className="import-ok">{apercu.nb_a_creer} à créer</span>
              <span>{apercu.nb_deja_presents} déjà présents</span>
              <span className={apercu.nb_rejetees ? "import-ko" : ""}>
                {apercu.nb_rejetees} rejetés
              </span>
            </div>

            {apercu.nb_rejetees > 0 && (
              <div className="import-liste">
                <p className="sous-info">
                  Ces lignes <strong>ne seront pas importées</strong>. Corrigez-les
                  dans le fichier et relancez, ou continuez sans elles.
                </p>
                {apercu.rejetees.map((r, i) => (
                  <div key={i} className="import-ligne">
                    <span className="import-num">ligne {r.ligne}</span>
                    <strong>{r.immatriculation || "—"}</strong>
                    <span className="import-motif">{r.motif}</span>
                  </div>
                ))}
              </div>
            )}

            {apercu.nb_a_creer > 0 && (
              <div className="import-liste">
                {apercu.a_creer.slice(0, 20).map((v, i) => (
                  <div key={i} className="import-ligne">
                    <span className="import-num">ligne {v.ligne}</span>
                    <strong>{v.immatriculation}</strong>
                    <span className="import-motif">
                      {v.categorie}
                      {v.marque ? ` · ${v.marque}` : ""}
                      {v.hayon ? " · hayon" : ""}
                    </span>
                  </div>
                ))}
                {apercu.nb_a_creer > 20 && (
                  <p className="sous-info">
                    … et {apercu.nb_a_creer - 20} autre(s).
                  </p>
                )}
              </div>
            )}
          </div>
        )}

        {resultat && (
          <div className="import-apercu">
            <p className="note-info">
              <strong>{resultat.crees} véhicule(s) importé(s).</strong>{" "}
              {resultat.nb_deja_presents > 0 &&
                `${resultat.nb_deja_presents} étaient déjà présents. `}
              {resultat.nb_rejetees > 0 &&
                `${resultat.nb_rejetees} ligne(s) rejetée(s).`}
            </p>
            <p className="sous-info">
              Les échéances de contrôle technique ont été créées, et les VGP
              pour les véhicules équipés d’un hayon.
            </p>
          </div>
        )}

        <div className="modal-actions">
          <button className="btn" onClick={onFermer}>
            {resultat ? "Fermer" : "Annuler"}
          </button>
          {!apercu && !resultat && (
            <button
              className="btn-accent"
              disabled={!fichier || enCours}
              onClick={() => envoyer(false)}
            >
              {enCours ? "Lecture…" : "Vérifier le fichier"}
            </button>
          )}
          {apercu && !resultat && (
            <button
              className="btn-accent"
              disabled={enCours || apercu.nb_a_creer === 0}
              onClick={() => envoyer(true)}
            >
              {enCours
                ? "Import…"
                : `Importer les ${apercu.nb_a_creer} véhicules`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
